import type { Control, DynamicFlatNode, TelemetryDataValues } from 'commons';
import Dexie, { type Table } from 'dexie';

export class DataTableDB extends Dexie {
  /**
   * Channel data table
   */
  channelData!: Table<{ timeseries: TelemetryDataValues[]; uuid: string }, string>;
  /**
   * Channel information table
   */
  channelInfo!: Table<DynamicFlatNode, string>;
  /**
   * Table for controls, which are used in the sensor table.
   */
  controls!: Table<Control, string>;
  /**
   * @description Initializes the database with versioning and table schemas.
   */
  constructor() {
    super('ngdexieliveQuery');
    this.version(3).stores({
      channelData: 'uuid',
      channelInfo: 'id',
      controls: 'id',
    });
  }
}
export const db = new DataTableDB();
